export default "__VITE_ASSET__BpP5Qn3A__"